import type { PipeTransform } from '@angular/core';
import { inject, Pipe, Signal } from '@angular/core';

import { I18nPlatformService } from './i18n.service';

@Pipe({
  name: 'platformTranslate',
  standalone: true,
  pure: true,
})
export class PlatformTranslatePipe implements PipeTransform {
  #i18nPlatformService = inject(I18nPlatformService);

  transform(value: string): Signal<string> {
    return this.#i18nPlatformService.tSignal(value);
  }
}
